module.exports = __webpack_public_path__ + "img/wallet.f901b37f.png";